import request from '@/config/request'

export default {
    searchAddress: function (code) {
        return request({
            url: '/customer/address/searchaddress',
            method: 'post',
            params: {
                code: code,
            }
        })
    },
    searchListAddress: function (customerCode ,status) {
        return request({
            url: '/customer/address/searchlistaddress',
            method: 'post',
            params: {
                customercode: customerCode,
                status: status,
            }
        })
    },
    addAddress: function (customerCode ,nickName,mobile,province,city,county,address,isDefault,status) {
        return request({
            url: '/customer/address/addaddress',
            method: 'post',
            params: {
                customercode: customerCode,
                nickname: nickName,
                mobile: mobile,
                province: province,
                city: city,
                county: county,
                address: address,
                isdefault: isDefault,
                status: status,
            }
        })
    },
    editAddress: function (code ,nickName,mobile,province,city,county,address,isDefault) {
        return request({
            url: '/customer/address/editaddress',
            method: 'post',
            params: {
                code: code,
                nickname: nickName,
                mobile: mobile,
                province: province,
                city: city,
                county: county,
                address: address,
                isdefault: isDefault,
            }
        })
    },
    deleteAddress: function (code ) {
        return request({
            url: '/customer/address/deleteaddress',
            method: 'post',
            params: {
                code: code,
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/customer/address.js